import { render, staticRenderFns } from "./StudentHomeworkSourceReport.vue?vue&type=template&id=337b10db"
import script from "./StudentHomeworkSourceReport.vue?vue&type=script&lang=js"
export * from "./StudentHomeworkSourceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337b10db')) {
      api.createRecord('337b10db', component.options)
    } else {
      api.reload('337b10db', component.options)
    }
    module.hot.accept("./StudentHomeworkSourceReport.vue?vue&type=template&id=337b10db", function () {
      api.rerender('337b10db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/report_widgets/StudentHomeworkSourceReport.vue"
export default component.exports